import withToast, { withOldToast } from './with-toast';
import withError from './with-error';

export { withToast, withError, withOldToast };
